// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Dictionary from './Dictionary';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Dictionary);
